/** An access code typed on the landing, kept through the hosted login (same tab, so
 * sessionStorage survives the round trip) and taken once by the chooser. */
const KEY = "carrel.pendingCode";

export function savePendingCode(code: string): void {
  try {
    sessionStorage.setItem(KEY, code);
  } catch {
    // Private mode or blocked storage: the chooser simply starts empty.
  }
}

export function takePendingCode(): string | null {
  try {
    const code = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    return code;
  } catch {
    return null;
  }
}
